import FAVE from '../../assets/images/logo/FAVESOLUTION.png';
import TELKOM from '../../assets/images/logo/PT Telekomunikasi Indonesia.png';

let workTimeline = [
    {
        id: 1,
        title: "Developer Internship",
        location: "PT. Telekomunikasi Indonesia (Persero) Tbk.",
        date: "March 2023 - August 2023",
        description: "PT Telekomunikasi Indonesia (Persero) Tbk. (Telkom) is a State-Owned Enterprise (BUMN) which operates in the field of information and communication technology (ICT) services and telecommunications networks in Indonesia.",
        logo: TELKOM,
    },
    {
        id: 2,
        title: "FAVE SOLUTION Manager",
        location: "Bina Nusantara Computer Club",
        date: "January 2022 - March 2023",
        description: "FAVE Solution is a professional software house focused on development and services. FAVE Solution has spent many years providing IT Solution to companies in Indonesia. We create Websites and Mobile Apps with the utmost care for our clients.",
        logo: FAVE,
    },
]

export default workTimeline